export const MenuList = [
  {
    title: "Estudiantes",
    iconStyle: <i className="flaticon-381-user-9" />,
    to: "students",
  },
  {
    title: "Estudiantes en Mora",
    iconStyle: <i className="flaticon-381-calendar-7" />,
    to: "nonpay",
  },
  {
    title: "Reportes",
    iconStyle: <i className="flaticon-381-funnel" />,
    to: "report",
  },
  {
    title: "Cambio de Grados",
    iconStyle: <i className="flaticon-381-list-1" />,
    to: "degreechange",
  },
  {
    title: "Costos",
    classsChange: "mm-collapse",
    iconStyle: <i className="flaticon-381-calendar-7" />,
    content: [
      {
        title: "Conceptos",
        to: "concepts",
      },
      {
        title: "Periódicos",
        to: "request",
      },
      {
        title: "Mensuales",
        to: "monthly",
      },
      {
        title: "Anuales",
        to: "annualy",
      },
    ],
  },

  {
    title: "Configuraciones",
    iconStyle: <i className="flaticon-381-notebook-1" />,
    to: "config",
  },
  {
    title: "Administradores",
    iconStyle: <i className="flaticon-381-lock-2" />,
    to: "users",
  },
];
